(() => {
  const isHome = !!document.querySelector('main .slideshow, main .banner, .shopify-section .slideshow');
  if (isHome) document.body.classList.add('prg-home');

  const onScroll = () => {
    const scrolled = window.scrollY > 20;
    document.documentElement.classList.toggle('prg-scrolled', scrolled);
    document.body.classList.toggle('prg-scrolled', scrolled);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();